import { render, staticRenderFns } from "./LogoSpriteD.vue?vue&type=template&id=4b5fff0b&scoped=true&lang=pug&"
import script from "./LogoSpriteD.vue?vue&type=script&lang=js&"
export * from "./LogoSpriteD.vue?vue&type=script&lang=js&"
import style0 from "./LogoSpriteD.vue?vue&type=style&index=0&id=4b5fff0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5fff0b",
  null
  
)

export default component.exports